import { render, staticRenderFns } from "./template.vue?vue&type=template&id=7fe84ea4&scoped=true&"
import script from "./template.vue?vue&type=script&lang=js&"
export * from "./template.vue?vue&type=script&lang=js&"
import style0 from "./template.vue?vue&type=style&index=0&id=7fe84ea4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe84ea4",
  null
  
)

export default component.exports